import { useEffect } from "react";
import BlueprintBehaviorFlags from "../../blueprints/BlueprintBehaviorFlags";
import LoadingSpinner from "../../shared-components/LoadingSpinner";
import ErrorMessageContainer from "../../shared-components/ErrorMessageContainer";
import {
  useGetBehaviorKit,
  useGetBehaviorsByBehaviorKitId,
} from "../../api/CompaniesApi";
import KeywordSummary from "../KeywordGroups/KeywordSummary";

type Props = {
  behaviorKitUUID: string;
  isVisible: boolean;
};

const CompanyBehaviorKitDetail = ({ behaviorKitUUID, isVisible }: Props) => {
  const {
    isLoading: isLoadingBehaviorKit,
    data: baseBehaviorKit,
    mutate: loadBehaviorKit,
    error: errorBehaviorKit,
  } = useGetBehaviorKit();

  const {
    mutate: loadBehaviors,
    isLoading: loadingBehaviors,
    data: behaviors,
  } = useGetBehaviorsByBehaviorKitId();

  useEffect(() => {
    if (!baseBehaviorKit && isVisible) {
      loadBehaviorKit(behaviorKitUUID);
      loadBehaviors(behaviorKitUUID);
    }
  }, [
    baseBehaviorKit,
    behaviorKitUUID,
    isVisible,
    loadBehaviorKit,
    loadBehaviors,
  ]);

  if (isLoadingBehaviorKit) return <LoadingSpinner />;

  if (!isVisible || !baseBehaviorKit) return <></>;

  if (!behaviorKitUUID || errorBehaviorKit)
    return (
      <ErrorMessageContainer message="Error loading Blueprint information" />
    );
  return (
    <div className="mt-2 text-base text-left">
      <div className="p-2">
        <div className="rounded-md p-2 font-bold">Settings:</div>
        <span className="flex p-2 gap-2 my-2">
          {baseBehaviorKit.display_images
            ? "Show images on finished report"
            : "Don't show images on finished report"}
        </span>
      </div>
      {loadingBehaviors && <LoadingSpinner />}
      <BlueprintBehaviorFlags behaviors={behaviors} showActiveOnly={false} />
      {baseBehaviorKit?.lookback && (
        <div className="p-2">
          <div className="rounded-md p-2 font-bold">Lookback:</div>
          <span className="flex p-2 gap-2 my-2">
            {"Lookback period (months): "}
            <b>{baseBehaviorKit.lookback}</b>
          </span>
        </div>
      )}
      {behaviorKitUUID && (
        <KeywordSummary behaviorKitUUID={behaviorKitUUID} readOnly={true} />
      )}
    </div>
  );
};

export default CompanyBehaviorKitDetail;
